'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "SearchField": "Polaris-Picker-SearchField"
};

exports.default = styles;
